

<template>

	<div id="calendar_list_view_container">
	

		<div class="sidebar_filters">
			<section class="search_text_container">
				<div class="form-item">
					<input id="search_text" type="text" v-model='filters.searchText'>
				</div>
			</section>
	
			<section>
				<h3>By month <a class="clear" @click.prevent="clearByMonth()">Clear</a></h3>
				
				<div class="goup_filters">
					<div class="form-item">
						<label for="search_year">Year</label>
						<select name="search_year" id="search_year" v-model='filters.searchYear' @change='resetFromToDateSearch()'> 
							<option value="">select</option>
							<option :value="year" v-for='year in getYearRange'>{{year}}</option>

						</select>	
					</div>
					<div class="form-item" v-show='filters.searchYear != "" ' >
						<label for="search_year">Month</label>
						<select name="search_month" id="search_month" v-model='filters.searchMonth'> 
							<option value="" selected>select</option>
							<option :value="n-1" v-for='n in 12'>  {{ displayMonth(n-1) }} </option>
						</select>	
					</div>

				</div>

			</section>

			<section>
			<h3>By date <a class="clear" @click.prevent="clearByDate()">Clear</a></h3>
				<div class="goup_filters">
					<div class="form-item">
						<label for="search_day_start">From</label>
						<datepicker :value="filters.searchDateStart" v-model='filters.searchDateStart' @change="resetYearSearch()"></datepicker>
						
					</div>
					<div class="form-item">
						<label for="search_day_end">to</label>
						<datepicker :value="filters.searchDateEnd" v-model='filters.searchDateEnd' ></datepicker>
					</div>
				</div>

			</section>

		</div>

		<div class="scrollable">
			
		

		<ul class="calendar_list" v-if='listEvents.length > 0'>
			
			<li v-for="event in listEvents" :class="classList(event.dateStart)">

				<a :href="event.event_url" class="bg">
					
					<div class="top">
						
						<h3>{{event.longtitle}}</h3>
						<h4>
							<span v-if="isToday(event.dateStart)">Today</span>  
							<template v-if="event.dateStart == event.dateEnd"> 
								{{ displayDate(event.start) }} | {{event.datetime}}
							</template>
							<template v-if="event.dateStart != event.dateEnd && event.datetime == '(All day)' "> 
								{{ displayDate(event.start) }} to {{ displayDate(event.end) }} | {{event.datetime}}
							</template>  
							<template v-if="event.dateStart != event.dateEnd && event.datetime != '(All day)' "> 
								{{ displayDate(event.start, true) }} to {{ displayDate(event.end, true) }}
							</template>  
								
						</h4>
						

					</div>

					<div class="desc">
						<p>{{event.description}}</p>
					</div>

				</a>
				
			</li>
				

		</ul>

		<div class="no_results" v-else>
			Sorry, No results were found, try again with different filters
		</div>

		</div>
	</div>
</template>

<script>
	import store  from './CalendarStoreEvents'
	import moment from 'moment'
	import Datepicker from 'vuejs-datepicker';
	
	export default {
	  	name: 'calendar-list',
	  	components: {
	  		Datepicker
	  	},
		data () {
		    return {
		    	date: null, 
		    	filters : {searchText: '', searchYear: '' , searchMonth: '', searchDateStart: '', searchDateEnd:''},
		    	state: store.state, 
		    	listEvents : [], 
		    
		    }
		}, 
		mounted () {
			this.date = moment()

			this.listEvents = this.state.events

			this.filterEvents(); 
		},
		computed : {

			
			getLastYear(){
				let lastEvent = this.state.events[0]
				if(lastEvent){
					return moment(lastEvent['dateEnd']).format('YYYY')
				}
			},
			getFirstYear(){

				let sortedEvents = _.sortBy(this.state.events, function(o) { return new moment(o.dateStart); });


				let firstEvent = sortedEvents[0]



				if(firstEvent){
					return moment(firstEvent['dateStart']).format('YYYY')
				}
			},
			getYearRange(){
				var yearRange = []
				var start = this.getFirstYear
				var end = this.getLastYear

				while( start <= end ){
					yearRange.push(start++)
				}

				return yearRange
			}
			

		}, 
		methods: {

			clearByMonth(){
				this.filters.searchYear = ''; 
				this.filters.searchMonth = ''; 
			}, 
			clearByDate(){
				this.filters.searchDateStart = ''; 
				this.filters.searchDateEnd = ''; 
			}, 

			displayMonth(n){
				return moment().month(n).format("MMMM")
			},
			
			classList(date){

				let eventDate =  moment(date)
				let todayDate =  moment()
			
				if(eventDate == todayDate ){
					return 'isToday'
				} 
				else{
					let diff = eventDate.diff(todayDate, 'days') +1

					return 'daydiff-'+diff
				}
			},

			displayDate(date, hour=false){
				if(hour==false){
					if( moment(date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
						return moment(date).format(', DD MMMM')
					}
					else{
						return moment(date).format('dddd, DD MMMM YYYY')
					}
				}
				else{
					if( moment(date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
						return moment(date).format(', DD MMMM')+ ' '+ moment(date).format('HH')+ 'h' + moment(date).format('mm')
					}
					else{
						return moment(date).format('dddd, DD MMMM YYYY') + ' '+ moment(date).format('HH')+ 'h' + moment(date).format('mm')
						//return moment(date) +'test'
					}
				}
			},

			isToday(date){
				if( moment(date).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')){
					 return true
				}
			}, 
			filterEvents(){

				let events = this.state.events

				let searchText = this.filters.searchText
				let searchYear = this.filters.searchYear
				var searchMonth = this.filters.searchMonth
				let searchDateStart = this.filters.searchDateStart
				let searchDateEnd = this.filters.searchDateEnd
				

				if(searchText != ''){
					events = events.filter( event=>{
						return event.searchtext.toLowerCase().includes(searchText.toLowerCase())
					})
				}

				if( searchDateStart == '' && searchDateEnd == ''){

					

					if(searchYear != ''){
						let month = moment().month(searchMonth).format('MM')
						let searchMonthNew = searchYear+'-'+ month


						events = events.filter( event =>{
							if(searchMonth == ''){
								return moment(event.dateStart).format('YYYY') == searchYear
							}
							else{
								
								return moment(event.dateStart).format('YYYY-MM') == searchMonthNew
							}
						})
					}
					else{
						

						events = events.filter( event =>{
								
								return moment(event.dateStart).isSameOrAfter(moment()) == true
							
						})
					}

					
				}
				else{
					
					
					if(searchDateStart != '' && searchDateEnd == ''){	
						this.filters.searchYear = ''	
						events = events.filter( event =>{
							return moment(event.dateStart).isSameOrAfter(moment(searchDateStart), 'day')
							
						})
						
					}
					if(searchDateStart == '' && searchDateEnd != ''){	
						this.filters.searchYear = ''	
						events = events.filter( event =>{
							return moment(event.dateStart).isSameOrBefore(moment(searchDateEnd), 'day')

						})

						
					}
					if(searchDateStart != '' && searchDateEnd != ''){
						this.filters.searchYear = ''
						events = events.filter( event =>{
							return moment(event.dateStart).isBetween(moment(searchDateStart), moment(searchDateEnd), 'days', '[]')
						})

					}

				}
				
				this.listEvents = _.sortBy(events, function(o) { return new moment(o.dateStart); });
			}, 
			resetFromToDateSearch(){
				this.filters.searchDateStart = ''
				this.filters.searchDateEnd = ''
			}, 
			resetYearSearch(){
				
			}

		},

		watch: {
			state: {
				handler: function(value){

				

					this.listEvents = this.state.events
					this.filters = {searchText: '', searchYear: '' , searchMonth: '', searchDateStart: '', searchDateEnd:''},

					this.filterEvents()
				}, 
				deep: true
			},
			filters: {
				handler :function(after, before){
				
					this.filterEvents()



				}, 
				deep: true
			}
		}, 

		


	}

</script>


// WEBPACK FOOTER //
// CalendarList.vue?315929a2